/* import __COLOCATED_TEMPLATE__ from './teammate-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  selectedAdminLabel: string;
  listedAdmins: { text: string; description?: string; value: number; isSelected: boolean }[];
  isDisabled: boolean;
  showError: boolean;
  onSelectItem: (item: number) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const ManageConversationsDrawerTeammateDropdown = templateOnlyComponent<Signature>();
export default ManageConversationsDrawerTeammateDropdown;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ManageConversationsDrawer::TeammateDropdown': typeof ManageConversationsDrawerTeammateDropdown;
    'knowledge-hub/manage-conversations-drawer/teammate-dropdown': typeof ManageConversationsDrawerTeammateDropdown;
  }
}
